/**
 * Step 7 — Notifications [TYPE A — Recommended]
 *
 * WIP alerts, billing schedule, utilisation warnings.
 * Next always enabled. Nudge explains it should be done before first use.
 */

import { StepWrapper } from '../StepWrapper';
import { SettingsNotificationsPage } from '@/pages/settings-notifications';

interface StepProps {
  onNext: () => void;
  onBack: () => void;
  onSkip: () => void;
  isLastStep: boolean;
}

export function Step7Notifications({ onNext, onBack, onSkip, isLastStep }: StepProps) {
  return (
    <StepWrapper
      barState="default"
      barMessage="Configure alerts and schedules now — they trigger as soon as your team starts working."
      showBack={true}
      showSkip={true}
      nextLabel={isLastStep ? 'Finish Setup →' : 'Next Step →'}
      onNext={onNext}
      onBack={onBack}
      onSkip={onSkip}
    >
      <div className="rounded-lg border border-border overflow-hidden bg-background shadow-sm">
        <SettingsNotificationsPage />
      </div>
    </StepWrapper>
  );
}
